import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgShareOrContact(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M115.71 83.18 52.94 43.995l-9.21 8.92-.107 6.216-5.016-1.66L25.1 70.423c-.926.886-.399 2.445.875 2.591l14.681 1.695-.13 7.337 75.185 1.128v.005Z"
        fill="#78B441"
      />
      <path d="M115.71 83.18 43.73 52.915l-.107 6.216 72.087 24.044v.005Z" fill="#007A5F" />
      <path d="m40.526 82.053 75.184 1.127-75.055-8.465-.13 7.338Z" fill="#007A5F" />
      <path
        d="M38.058 56.884a.8.8 0 0 1 1.1 1.162l-13.6 12.875a.714.714 0 0 0 .41 1.226h.002l20.117 2.312h-.001l69.479 7.876a.8.8 0 1 1-.18 1.59l-69.48-7.876-20.118-2.312c-1.956-.224-2.752-2.632-1.328-3.978l13.599-12.875Z"
        fill="#0F172A"
      />
      <path
        d="M35.982 36.393c.797-.171 1.685-.146 2.495.318 1.069.614 1.612 1.796 1.705 2.88l.015.232c.11 2.385-1.337 4.517-3.042 5.813v-.001c-1.272.969-2.74 1.586-4.204 2.034.108.148.221.293.34.434l.167.19.001.002c1.528 1.698 3.678 2.783 5.961 3.646a.8.8 0 0 1-.566 1.497c-2.352-.89-4.796-2.084-6.584-4.073l-.196-.224a9.298 9.298 0 0 1-.756-1.033c-1.993.475-4.015.767-5.995 1.048-2.201.312-4.35.614-6.445 1.142h-.001c-3.312.83-6.478 2.245-8.988 4.45-2.511 2.206-4.314 5.237-4.659 8.483-.312 2.956.587 6.005 2.256 8.545 3.768 5.737 10.575 8.342 17.053 10.76a.8.8 0 0 1-.56 1.5c-6.372-2.38-13.725-5.133-17.83-11.382-1.836-2.794-2.868-6.208-2.51-9.592.395-3.72 2.441-7.098 5.194-9.516s6.171-3.926 9.653-4.8l.823-.196c1.927-.435 3.878-.707 5.79-.978 1.86-.264 3.683-.53 5.467-.932-.79-1.976-.853-4.231.3-6.248.721-1.266 1.788-2.273 2.948-3.043l.24-.153c.571-.35 1.235-.654 1.928-.803Zm1.699 1.706c-.37-.212-.827-.258-1.363-.142-.474.102-.968.322-1.426.602l-.193.123c-1.01.67-1.875 1.507-2.443 2.503v.001c-.896 1.566-.843 3.408-.125 5.059 1.491-.428 2.893-.996 4.055-1.882 1.492-1.135 2.555-2.885 2.401-4.632v-.002c-.06-.717-.412-1.347-.906-1.63Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgShareOrContact)
